/**
 * @generated SignedSource<<a3d8bfc6da7718704ea92a4474d5e2fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationScreenContent_presentation$data = {
  readonly canEdit: boolean | null | undefined;
  readonly description: string | null | undefined;
  readonly presenter: {
    readonly firstName: string;
    readonly lastName: string;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserItem_user" | "UserPrimaryPhoto_user">;
  } | null | undefined;
  readonly presenterFirstName: string | null | undefined;
  readonly presenterLastName: string | null | undefined;
  readonly prettyUrl: string;
  readonly title: string;
  readonly videoSourceUrl: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationEvents_presentation" | "PresentationGuilds_presentation" | "PresentationMetadata_presentation" | "PresentationVideoPlayer_presentation">;
  readonly " $fragmentType": "PresentationScreenContent_presentation";
};
export type PresentationScreenContent_presentation$key = {
  readonly " $data"?: PresentationScreenContent_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationScreenContent_presentation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationScreenContent_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoSourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "presenter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slugId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserPrimaryPhoto_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserItem_user"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationMetadata_presentation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationVideoPlayer_presentation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationEvents_presentation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PresentationGuilds_presentation"
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};

(node as any).hash = "8f53d5774f7decdb55580c0f8abb3af3";

export default node;
